var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2135_19485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9773 6.16285C15.9221 5.99313 15.7755 5.86945 15.5989 5.84382L10.6389 5.12304L8.42058 0.628468C8.34165 0.468468 8.17868 0.367188 8.00027 0.367188C7.82184 0.367188 7.6589 0.468468 7.57993 0.628468L5.36156 5.12304L0.401582 5.84382C0.225052 5.86945 0.0783335 5.99313 0.0232087 6.16282C-0.0319474 6.33254 0.0140525 6.51882 0.141833 6.64335L3.73082 10.1419L2.8837 15.082C2.85351 15.2579 2.92582 15.4355 3.07017 15.5404C3.15182 15.5998 3.24854 15.6299 3.34573 15.6299C3.42035 15.6299 3.49523 15.6122 3.56379 15.5761L8.00024 13.2437L12.4365 15.5761C12.5945 15.6591 12.7858 15.6453 12.9302 15.5404C13.0745 15.4355 13.1468 15.2578 13.1167 15.0819L12.2693 10.1419L15.8587 6.64332C15.9864 6.51882 16.0325 6.33254 15.9773 6.16285Z",
    fill: "#00A094"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2135_19485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/starFilled.bc64a5b04ba3682ecd200a53173f77e0.svg";
export { ForwardRef as ReactComponent };